import { render } from "./CadCategoriasNoticias.vue?vue&type=template&id=11d7c8e2"
import script from "./CadCategoriasNoticias.vue?vue&type=script&lang=js"
export * from "./CadCategoriasNoticias.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__